import { FormControl, Grid, Button, TextField, Switch } from '@material-ui/core'
import React from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete';
import DatePicker from 'react-date-picker';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Typography, Text } from '@mui/material';

// import { ValidateDateUTC } from '../../helpers/textValidation';

const NewFormFields = ({ fields, onChange, grid }) => {

    return (
        // <Grid xs={12} className="mbold mt30">
        <>
            {
                fields.map((field) => (<DynamicFormField grid={grid} fields={field} onChange={onChange} />))
            }
        </>
        // </Grid>

    )
}

const DynamicFormField = ({ fields, onChange, type, grid }) => {
    let Component = {
        1: <TextComponent grid={grid} onChange={onChange} data={fields} />,
        2: <DatePickerComponent grid={grid} onChange={onChange} data={fields} />,
        3: <DropDownComponent grid={grid} onChange={onChange} data={fields} />,
        4: <CheckRide grid={grid} onChange={onChange} data={fields} />,
        5: <TimeComponent grid={grid} onChange={onChange} data={fields} />,
        6: <SwitchButton grid={grid} onChange={onChange} data={fields} />,
        7: <Comment grid={grid} onChange={onChange} data={fields} />,
        8: <SimpleText grid={grid} onChange={onChange} data={fields} />,
        9: <Button className={fields.className} onClick={fields.onClick}>{fields.buttonText}</Button>,
        10: <TextAreaField grid={grid} onChange={onChange} data={fields} />,
        11: <DatePickerComponentMaxDate grid={grid} onChange={onChange} data={fields} />

    }

    return (
        Component[fields?.type]
    )
}

export default NewFormFields


const TextComponent = ({ data, onChange }) => {

    let { grid = 12, keyName, name,
        initial, isDisabled, className,
        isRequired, validation, type,
        fieldType = 'text', nameplaceholder,
        currentVal = false, helperText } = data;

    return (

        <Grid xs={grid} style={{ marginBottom: `${grid ? "0px" : "10px"}`, marginTop: `${grid ? "20px" : "0px"}` }}>
            <div style={{ marginBottom: `${grid ? "0px" : "15px"}` }}>

                <Grid xs={12} className={`${grid ? "mbold" : ""} ${className}`} style={{ marginBottom: '10px' }}>
                    {name}
                </Grid>
                <TextField
                    disabled={isDisabled}
                    defaultValue={initial}
                    value={currentVal ? initial : null}
                    type={fieldType}
                    style={{ background: 'white', borderRadius: '10px', marginBottom: `${grid ? "0px" : "20px"}` }}
                    id="outlined-basic"
                    errorMessages={['this field is required', 'email is not valid']}
                    onChange={(e) => onChange(e.target.value, keyName, type)}
                    required={isRequired}
                    placeholder={nameplaceholder}
                    error={validation ? true : false}
                    helperText={validation != false ? validation : ""}
                    variant="outlined" className="w100p" />
            </div>
            {helperText?.length && <p style={{ fontSize: '10px' }}>{helperText} </p>}
        </Grid>
    )
}

const DropDownComponent = ({ data, onChange }) => {

    let { grid = 12, keyName, name, initial, options, key, className, isRequired, type, value, customStyle } = data;

     
    return (
        <Grid xs={grid} style={{ marginBottom: `${grid ? "0px" : "10px"}`, marginTop: `${grid ? "20px" : "0px"}` }}>

            <div style={{ marginBottom: `${grid ? "0px" : "20px"}`, marginTop: `${customStyle ? customStyle.margin.top : ""}` }}>
                <Grid xs={12} className={`${grid ? "mbold" : ""} ${className}`} style={{ marginBottom: '10px', }}>{name}</Grid>
                <Autocomplete
                    className="w100p"
                    id="combo-box-demo"
                    options={options}
                    style={{ background: 'white', borderRadius: '10px', fontWeight: 'bolder!important' }}
                    getOptionLabel={options ? (option) => option?.[key] : ""}
                    defaultValue={initial}
                    onChange={(event, value) => onChange(value, keyName, type)}
                    renderInput={(params) => <TextField {...params} variant="outlined" placeholder='Select'
                        required={isRequired}
                    />
                    }
                />
            </div>
        </Grid>
    )
}


const DatePickerComponent = ({ data, onChange }) => {

    let { grid = 12, name, initial, keyName, type, className } = data;

    return (
        <Grid className={`${className}`} xs={grid} style={{ marginBottom: `${grid ? "0px" : "10px"}`, marginTop: `${grid ? "20px" : "0px"}` }}>

            <div style={{ marginBottom: "20px" }}>
                <Grid xs={6} style={{ marginBottom: '10px' }}>{name}</Grid>
                <DatePicker
                    value={initial}
                    required={true}
                    onChange={(value) => onChange(value, keyName, type)}
                    id="dob"
                    style={{ background: 'white', borderRadius: '10px' }}
                    className="datePickerReact w100p bg-white react-date-picker"
                    message={'please fill this field'}
                    onCalendarClose={(e) => {
                         
                    }}
                />
            
                 
            </div>
        </Grid>
    )
}
const DatePickerComponentMaxDate = ({ data, onChange }) => {

    let { grid = 12, name, initial, keyName, type, className } = data;

    return (
        <Grid className={`${className}`} xs={grid} style={{ marginBottom: `${grid ? "0px" : "10px"}`, marginTop: `${grid ? "20px" : "0px"}` }}>

            <div style={{ marginBottom: "20px" }}>
                <Grid xs={6} style={{ marginBottom: '10px' }}>{name}</Grid>
            
                 <DatePicker
                    value={initial}
                    required={true}
                    onChange={(value) => onChange(value, keyName, type)}
                    id="dob"
                    type='date1'
                    style={{ background: 'white', borderRadius: '10px' }}
                    className="datePickerReact w100p bg-white react-date-picker"
                    message={'please fill this field'}
                    maxDate={new Date()}
                />
                 
            </div>
        </Grid>
    )
}


const TimeComponent = ({ data, onChange }) => {

    let { grid = 12, name, keyName, type, className } = data;

    return (
        <Grid className={`${className}`} xs={grid} style={{ marginBottom: `${grid ? "0px" : "10px"}`, marginTop: `${grid ? "20px" : "0px"}` }}>
            <div style={{ marginBottom: "20px" }}>
                <Grid xs={6} style={{ marginBottom: '10px' }} >{name}</Grid>
                <TextField
                    required={false}
                    id="time"
                    type="time"
                    onChange={(e) => onChange(e.target.value, keyName, type)}
                    className="DateTimePicker"
                    defaultValue="HH:mm:ss"
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </div>
        </Grid>

    )
}



const CheckRide = ({ data, onChange }) => {

    let { grid = 12, keyName, name, initial, type, isRequired, tabIndexData } = data;
    return (
        <div style={{ marginBottom: "20px" }}>
            <Grid xs={12} style={{ marginBottom: '10px' }}>{name}</Grid>
            <FormControl>
                <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    onChange={(e) => onChange(e.target.value, keyName, type)}                >
                    <FormControlLabel control={<Radio required />} value="YES" label="Yes" />
                    <FormControlLabel control={<Radio required />} value="NO" label="No" />
                    <FormControlLabel control={<Radio required />} value="N/A" label="N/A" />
                </RadioGroup>
            </FormControl>
        </div>
    )
}




const Comment = ({ data, onChange }) => {

    let { grid = 12, keyName, name, initial, isDisabled, message, isRequired, validation, type, fieldType, nameplaceholder, minRows } = data;

    return (

        <Grid xs={grid} style={{ marginBottom: `${grid ? "0px" : "10px"}`, marginTop: `${grid ? "20px" : "0px"}` }}>
            <div style={{ marginBottom: `${grid ? "0px" : "15px"}` }}>

                <Grid xs={16} className={`${grid ? "mbold" : ""}`} style={{ marginBottom: '10px' }}>{name}</Grid>
                <TextField
                    disabled={isDisabled}
                    defaultValue={initial}
                    type={fieldType}
                    style={{ background: 'white', borderRadius: '10px', marginBottom: `${grid ? "0px" : "20px"}`, }}
                    id="outlined-basic"
                    errorMessages={['this field is required', 'email is not valid']}
                    onChange={(e) => onChange(e.target.value)}
                    required={isRequired}
                    error={validation ? true : false}
                    helperText={validation != false ? validation : ""}
                    variant="outlined" className="w100p"
                    multiline
                    minRows={minRows}
                />
            </div>
            <p style={{ fontSize: '10px' }}>Please leave this field empty if you have no comments  </p>
        </Grid>
    )
}


const SwitchButton = ({ data, onChange }) => {

    let { grid = 12, keyName, name, className, initial, options, type, handleChange, checked, isRequired } = data;
    return (
        <Grid className={`${className}`} xs={grid}
            style={{
                marginBottom: `${grid ? "0px" : "10px"}`,
                marginTop: `${grid ? "20px" : "0px"}`,
            }}>
            <Grid xs={12} className={`${grid ? "mbold" : ""}`} style={{ marginBottom: '10px' }}>{name}</Grid>
            <Switch
                checked={checked}
                onChange={(event, value) => onChange(value, keyName)}
                required={isRequired}
                inputProps={{ 'aria-label': 'controlled' }}
            />
        </Grid>
    )
}

const SimpleText = ({ data, onChange }) => {

    let { grid = 12, keyName, name, className } = data;

    return (

        <Grid xs={grid} style={{ marginBottom: `${grid ? "0px" : "10px"}`, marginTop: `${grid ? "20px" : "0px"}` }}>
            <div style={{ marginBottom: `${grid ? "0px" : "15px"}` }}>

                <Grid xs={12} className={`${grid ? "mbold" : ""} ${className}`} style={{ marginBottom: '10px' }}>
                    {name}
                </Grid>

            </div>
        </Grid>
    )
}




const TextAreaField = ({ data, onChange }) => {

    let { grid = 12, keyName, name, initial, isDisabled, message, isRequired, validation, type, fieldType, nameplaceholder, minRows, helperText } = data;

    return (

        <Grid xs={grid} style={{ marginBottom: `${grid ? "0px" : "10px"}`, marginTop: `${grid ? "20px" : "0px"}` }}>
            <div style={{ marginBottom: `${grid ? "0px" : "15px"}` }}>

                <Grid xs={16} className={`${grid ? "mbold" : ""}`} style={{ marginBottom: '10px' }}>{name}</Grid>
                <textarea
                    disabled={isDisabled}

                    defaultValue={initial}
                    style={{ background: 'white', borderRadius: '10px', marginBottom: `${grid ? "0px" : "20px"}`, resize: "none" }}
                    id="outlined-basic"
                    onChange={(e) => onChange(e.target.value, keyName)}
                    required={isRequired}
                    className="w100p"
                    rows={minRows}
                />
            </div>
            {helperText && <p style={{ fontSize: '10px' }}>{helperText}</p>}
        </Grid>
    )
}

